import { Eye } from "lucide-react";
import React, { useCallback, useMemo } from "react";

import { Badge } from "../../../../components/ui/badge";
import { Button } from "../../../../components/ui/button";
import { Checkbox } from "../../../../components/ui/checkbox";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "../../../../components/ui/dropdown-menu";
import { cn } from "../../../../handlers/cn.utils";
import { JobApplicationState, JobApplicationStatus } from "../../../../handlers/enums";
import { dateObjToYMD } from "../../../../handlers/utilityFunctions";

function MobileJobCard({
	data,
	selected,
	handleRowClick,
	getStatusColor,
	handleStatusChange,
	openJobDetails,
	onSelect,
}) {
	const [job, setJob] = React.useState(data);

	const status = useMemo(() => {
		const stat = job.status[job.status.length - 1];
		return stat?.status;
	}, [job.status]);

	const handleStatusChange_Internal = useCallback(
		(newStatus) => {
			// optimistic update
			const statusArray = [
				...job.status,
				{
					status: newStatus,
					state: JobApplicationState.NOT_STARTED,
				},
			];

			setJob((prev) => ({ ...prev, status: statusArray }));

			handleStatusChange(job._id, newStatus, status);
		},
		[job._id, job.status, handleStatusChange, status],
	);

	const handleViewClick = useCallback(() => {
		openJobDetails(job);
	}, [openJobDetails, job]);

	return (
		<div
			className={cn("cursor-pointer group border p-3 bg-white rounded-xs", selected && "bg-blue-50")}
			onClick={handleRowClick}
		>
			<div className="flex items-center justify-between mb-2">
				<div onClick={(e) => e.stopPropagation()}>
					<DropdownMenu>
						<DropdownMenuTrigger asChild>
							<Badge
								variant="default"
								className={`text-[10px] py-0.5 px-1 mb-2 rounded cursor-pointer ${getStatusColor(status)}`}
							>
								{status}
							</Badge>
						</DropdownMenuTrigger>
						<DropdownMenuContent>
							{Object.values(JobApplicationStatus).map((status) => (
								<DropdownMenuItem key={status} onClick={() => handleStatusChange_Internal(status)}>
									{status}
								</DropdownMenuItem>
							))}
						</DropdownMenuContent>
					</DropdownMenu>
				</div>
				<div className="text-right" onClick={(e) => e.stopPropagation()}>
					<Button variant="outline" size="sm" onClick={handleViewClick}>
						<Eye size={12} />
					</Button>
				</div>
			</div>
			<div className="w-12 hidden" onClick={(e) => e.stopPropagation()}>
				<Checkbox name={job._id} id={job._id} checked={selected} onCheckedChange={onSelect} />
			</div>
			<div className="font-medium flex items-center gap-2">
				<div>
					<p className="text-sm text-gray-500">{job.companyName}</p>
					<p className="">{job.jobTitle}</p>
				</div>
			</div>
			<div className="text-xs text-gray-500">{job.location}</div>
			<div className="text-xs text-gray-500">{job.salaryRange}</div>

			<div className="text-nowrap text-xs text-gray-500">{dateObjToYMD(job.createdOn)}</div>
		</div>
	);
}

export default MobileJobCard;
